/**
 * Utility function that returns the query-params for the current web-page.
 */
export function getQueryParams() {
  const search = window.location.search;
  if (!search || search === '') return {}; // nothing to log
  const params = new URLSearchParams(search);
  if ([...params.keys()].length === 0) return {};
  // Convert to a plain object for cleaner logging
  const queryObject: Record<string, string> = {};
  params.forEach((value, key) => {
    queryObject[key] = value;
  });
  return queryObject;
}
